// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import "./lang/i18n";
import { AuthProvider, useAuth } from "./context";
import { getAccess } from "./permissions/Permissions";
import { createAppRouter } from "./Routes/AppRoutes";
import { NewRecordsProvider } from "./context/NewRecordsProvider";
import { ThemeProvider } from "@emotion/react";
import theme from "./Components/theme/theme";
import useFetchObjects from "./api/useFetchObjects";

const queryClient = new QueryClient({
  defaultOptions: {},
});

const AppWithRouter = () => {
  const auth = useAuth();
  const token = auth?.user?.token;
  const user = auth?.user;

  const { data } = useFetchObjects(
    ["permissions-users"],
    `users/${user?.user?.id}/`,
    token,
  );

  const transformPermissions = (data) => {
    if (!data) return {};

    return {
      reception: data.reception || false,
      pharmacy: data.pharmacy || false,
      doctor: data.doctor || false,
      nurse: data.nurse || false,
      x_ray: data.x_ray || false,
      ultrasounds: data.ultrasounds || false,
      laboratory: data.laboratory || false,
      echo: data.echo || false,
      finance: data.finance || false,
      hr: data.hr || false,
      dental: data.dental || false,
      call_center: data.call_center || false,
      limited_data_view: data.limited_data_view || false,
      is_manager_in_call_center: data.is_manager_in_call_center || null,
      beauty: data.beauty || false,
      htPatient: data.htPatient || false,
      operations: data.operations || false,
    };
  };

  const permissions = transformPermissions(data);
  console.log(permissions);

  const userPermissions = getAccess(permissions, user?.user?.isAdmin);
  const router = createAppRouter(userPermissions);

  return <RouterProvider router={router} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <NewRecordsProvider>
        <ToastContainer />
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider>
            <React.StrictMode>
              <AppWithRouter />
            </React.StrictMode>
          </SnackbarProvider>
        </QueryClientProvider>
      </NewRecordsProvider>
    </AuthProvider>
  </ThemeProvider>,
);
